const MODULE_NAME = 'ReportsModule';

// eslint-disable-next-line import/prefer-default-export
export const IS_INTERNAL_REPORT = `${MODULE_NAME}/isInternalReport`;
